module.exports = [{
      plugin: require('/Volumes/workspace/ldaws-public/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
